import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

// vuefire
import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

// feather icons
import feather from 'vue-icon'
Vue.use(feather, 'v-icon')

// long touch
import longPressDirective from '@/plugins/longPressDirective'
Vue.use(longPressDirective)

// hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
